import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Our Clients', href: '/our-clients' }
  ];

  return (
    <header
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        background: 'rgba(255, 255, 255, 0.6)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderBottom: '1px solid var(--border-light)',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
      }}
    >
      <nav className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem 1.5rem', height: '6rem' }}>
        {/* Logo */}
        <div className="header-logo">
          <img 
            src="/ibtecon-logo.png" 
            alt="ibTECON Logo" 
            style={{ 
              height: '100px', 
              width: 'auto',
              objectFit: 'contain'
            }} 
          />
        </div>

        {/* Desktop Navigation */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} className="desktop-nav">
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                style={{
                  color: 'var(--text-primary)',
                  textDecoration: 'none',
                  fontFamily: 'system-ui, sans-serif',
                  fontSize: '1rem',
                  fontWeight: '500',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  transition: 'background 0.2s ease, color 0.2s ease',
                  background: 'rgba(36, 67, 89, 0.08)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(36, 67, 89, 0.15)';
                  e.target.style.color = '#244359';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(36, 67, 89, 0.08)';
                  e.target.style.color = 'var(--text-primary)';
                }}
              >
                {link.name}
              </Link>
            ))}
          </div>
          <Link to="/contact" className="btn-primary">
            Schedule a Meet
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '0.5rem',
            color: 'var(--text-primary)'
          }}
          className="mobile-menu-btn"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div
          style={{
            background: 'white',
            borderTop: '1px solid var(--border-light)',
            padding: '1rem'
          }}
          className="mobile-nav"
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                onClick={() => setMobileMenuOpen(false)}
                style={{
                  color: 'var(--text-primary)',
                  textDecoration: 'none',
                  fontFamily: 'system-ui, sans-serif',
                  fontSize: '1rem',
                  fontWeight: '500',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  transition: 'background 0.2s ease, color 0.2s ease',
                  background: 'rgba(36, 67, 89, 0.08)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(36, 67, 89, 0.15)';
                  e.target.style.color = '#244359';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(36, 67, 89, 0.08)';
                  e.target.style.color = 'var(--text-primary)';
                }}
              >
                {link.name}
              </Link>
            ))}
            <Link 
              to="/contact" 
              className="btn-primary" 
              style={{ marginTop: '0.5rem' }}
              onClick={() => setMobileMenuOpen(false)}
            >
              Schedule a Meet
            </Link>
          </div>
        </div>
      )}

      <style>{`
        @media (min-width: 768px) {
          .mobile-menu-btn,
          .mobile-nav {
            display: none !important;
          }
        }
        
        @media (max-width: 767px) {
          .desktop-nav {
            display: none !important;
          }
          
          nav.container {
            position: relative;
          }
          
          .header-logo {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1;
          }
          
          .mobile-menu-btn {
            position: relative;
            z-index: 2;
            margin-left: auto;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;